function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "\\u2705-Project",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Moje-Centrum---Szczego\\u0301\\u0142y-Umowy-Papierowej",
  transform: "translate(-307.000000, -1051.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-35",
  transform: "translate(272.000000, 1016.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "New-Icon/Archive",
  transform: "translate(35.000000, 32.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Safespace",
  x: 0,
  y: 0,
  width: 21,
  height: 21
}), /*#__PURE__*/React.createElement("g", {
  id: "archiwum_wiadomosci",
  transform: "translate(0.000000, 3.150000)",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#48A9A1",
  opacity: 0.2,
  x: 0.966,
  y: 3.7275,
  width: 15.561,
  height: 10.521
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.01,3.5595 L17.01,3.5595 L17.01,3.5595 C16.9591754,3.46414695 16.8873718,3.38157289 16.8,3.318 L16.8,3.318 L16.8,3.318 C16.717113,3.26837749 16.6234457,3.23955678 16.527,3.234 L0.966,3.234 C0.869554303,3.23955678 0.77588701,3.26837749 0.693,3.318 L0.693,3.318 L0.693,3.318 C0.619350057,3.37882051 0.558652125,3.45380031 0.5145,3.5385 L0.5145,3.5385 L0.5145,3.5385 C0.504464515,3.5940504 0.504464515,3.6509496 0.5145,3.7065 L0.5145,14.2065 C0.5145,14.4964495 0.749550506,14.7315 1.0395,14.7315 L16.5165,14.7315 C16.8064495,14.7315 17.0415,14.4964495 17.0415,14.2065 L17.0415,3.7065 C17.0389125,3.6561329 17.0282779,3.60650487 17.01,3.5595 L17.01,3.5595 Z M15.96,12.7785 L11.9175,8.5785 L15.96,4.872 L15.96,12.7785 Z M15.4245,13.7235 L2.0265,13.7235 L6.3,9.3345 L8.4,11.235 C8.49583464,11.3266052 8.62449604,11.3757992 8.757,11.3715 C8.88610293,11.3741477 9.01089035,11.3249891 9.1035,11.235 L11.2035,9.3345 L15.4245,13.7235 Z M6.1845,4.2735 L15.141,4.2735 L11.214,7.875 L10.437,8.5785 L8.7465,10.1325 L7.0455,8.5785 L6.3,7.875 L2.31,4.2525 L6.1845,4.2735 Z M5.502,8.652 L1.4595,12.852 L1.4595,4.9245 L5.502,8.652 Z",
  id: "Shape",
  fill: "#555150"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.5615,0.451499769 L4.0005,0.451499769 C3.73954546,0.451499769 3.528,0.663045456 3.528,0.924 L3.528,2.415 L17.43,2.415 C17.6909545,2.415 17.9025,2.62654546 17.9025,2.8875 L17.9025,11.9175 L19.5615,11.9175 C19.8224545,11.9175 20.034,11.7059545 20.034,11.445 L20.034,0.945 C20.0397352,0.816087854 19.9924976,0.690438615 19.9032574,0.597232236 C19.8140173,0.504025857 19.6905396,0.451372488 19.5615,0.451499769 Z",
  id: "Path",
  fill: "#48A9A1"
}))))));

var SvgNews = function SvgNews(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "15px",
    viewBox: "0 0 21 15",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNews, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/News.dda414a4.svg";
export { ForwardRef as ReactComponent };